import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useCreateMonitorStationOperators() {
  const axiosPrivate = useAxiosPrivate();
  return useMutation({
    mutationFn: (data) => {
      return axiosPrivate({
        method: "POST",
        url: "/Users/MonitorStationOperators/Create",
        data,
      });
    },
  });
}

export default useCreateMonitorStationOperators;
